import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Login } from "../pages/Login";
import LoginSignUp from "../views/LoginSignUp";
import Dashboard from "../views/Dashboard";
import ProtectedRoute from "../utils/ProtectedRoute";

import ViewSuperSet from "../pages/Dashboard/Visualizer/ViewSuperSet";
import {
  ListAnticipation,
  ViewAnticipation,
} from "../pages/Dashboard/Anticipation";
import HomePage from "../pages/Dashboard/Home/HomePage";
import Signup from "../pages/SignUp";
import {
  ForgotPassword,
  ForgotPasswordEmailSent,
} from "../pages/ResetPassword";
import CreditRequest from "../pages/Dashboard/CreditSimulation";
import ReceivablePage from "../pages/Dashboard/Receive";
import { ListConsent } from "../pages/Dashboard/Consent";
import MobileWarn from "../components/Mobile/MobileWarn";
import Profile from "../pages/Dashboard/Profile/Profile";
import PasswordEditor from "../pages/Dashboard/Profile/SecurityInformation/Edit/PasswordEditor";
import PasswordReset from "../pages/Dashboard/Profile/SecurityInformation/Edit/PasswordReset";
import {
  ProfileEmailEditor,
  ProfileMobilePhoneEditor,
  ProfileNameEditor,
} from "../pages/Dashboard/Profile/PersonalInformation/Edit";
import EmailConfirmation from "../pages/Dashboard/EmailConfirmation/EmailConfirmation";

const Router: React.FC = () => {
  const minDelendWidth = 420;
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<LoginSignUp />}>
          <Route index element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/email-sent" element={<ForgotPasswordEmailSent />} />
        </Route>
        <Route
          path="email-confirmation/:token"
          element={<EmailConfirmation />}
        />
        <Route
          path="dashboard"
          element={
            window.innerWidth > minDelendWidth ? (
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            ) : (
              <MobileWarn />
            )
          }
        >
          <Route index element={<HomePage />} />
          <Route path="profile">
            <Route index element={<Profile />} />
            <Route path="edit">
              <Route path="name" element={<ProfileNameEditor />}></Route>
              <Route path="password" element={<PasswordEditor />}></Route>
              <Route path="password/reset" element={<PasswordReset />}></Route>
              <Route path="phone" element={<ProfileMobilePhoneEditor />} />
              <Route path="email" element={<ProfileEmailEditor />} />
            </Route>
          </Route>
          <Route path="consents" element={<ListConsent />} />
          <Route path="receivable" element={<ReceivablePage />} />
          <Route path="receivable/credit" element={<CreditRequest />} />
          <Route path="anticipation" element={<ListAnticipation />} />
          <Route
            path="anticipation/detail/:uuid"
            element={<ViewAnticipation />}
          />
          <Route
            path="view/customer/dashboard/:customerId"
            element={<ViewSuperSet />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
